import React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import ModalActionableBase from '../ModalActionableBase';
import { Description } from '../styles';

const ConfirmationModal: React.FunctionComponent<IInnerProps & IOuterProps> = ({
  title,
  description,
  confirmAction,
  isLoading,
  isOpen,
  toggleModal,
  confirmText,
  emailInputRequired,
  email,
  setEmail
}) => {
  return (
      <ModalActionableBase
          isOpen={isOpen}
          onCloseModal={() => toggleModal(false)}
          loading={isLoading}
          title={title}
          confirmText={confirmText}
          confirmAction={confirmAction}
          emailInputRequired={emailInputRequired}
          email={email}
          setEmail={setEmail}
      >
        <Description>{description}</Description>
      </ModalActionableBase>
  );
}

export default compose<IInnerProps, IOuterProps>(
  withState('isLoading', 'setLoading', false),
  withHandlers({
    confirmAction: ({
      onConfirm,
      setLoading,
      toggleModal,
    }: IInnerProps & IOuterProps) => () => {
      setLoading(true);
      return onConfirm().finally(() => {
        setLoading(false);
        toggleModal(false);
      });
    },
  }),
)(ConfirmationModal);

interface IInnerProps {
  isLoading: boolean;
  setLoading: (value: boolean) => void;
  confirmAction: () => void;
}

interface IOuterProps {
  isOpen: boolean;
  toggleModal: (value: boolean) => void;
  title: string;
  description: string;
  onConfirm: () => Promise<any>;
  confirmText: string;
  emailInputRequired?: boolean;
  email?: string;
  setEmail?: any;
}
